import moment from 'moment';

export const TARGET_KINDS = [
  { id: 'search', label: 'Search' },
  { id: 'product', label: 'Product' },
  { id: 'category', label: 'Category' },
  { id: 'collection', label: 'Collection' },
  { id: 'department', label: 'Department' },
  { id: 'brand', label: 'Brand' },
  { id: 'shopmy', label: 'ShopMy' }
];

export const TABS = [
  { id: 'ideas', label: 'Ideas', statuses: ['proposed'] },
  { id: 'wheel', label: 'Hero library', statuses: ['accepted'] },
  { id: 'shelved', label: 'Shelved', statuses: ['rejected', 'archived'] }
];

export const kindLabel = kind => TARGET_KINDS.find(item => item.id === kind)?.label || 'Search';

export const targetSummary = hero => {
  if (hero.targetKind === 'shopmy') return 'ShopMy editorial';
  if (hero.targetLabel) return `${kindLabel(hero.targetKind)} · ${hero.targetLabel}`;
  if (hero.targetKind === 'search') return hero.searchQuery || 'Search spark';
  return kindLabel(hero.targetKind);
};

export const hasMedia = hero => !!(hero.videoUrl || hero.imageUrl);

export const todayContextLine = (now = moment()) => `${now.format('dddd, MMMM D')} — ${seasonWord(now)} in the air.`;

const seasonWord = now => {
  const month = now.month();
  if (month >= 2 && month <= 4) return 'spring';
  if (month >= 5 && month <= 7) return 'summer';
  if (month >= 8 && month <= 10) return 'fall';
  return 'winter';
};

export const payloadFromHero = hero => ({
  term: hero.term,
  searchQuery: hero.searchQuery || '',
  status: hero.status,
  isLive: !!hero.isLive,
  videoUrl: hero.videoUrl || '',
  sourceProductUrl: hero.sourceProductUrl || '',
  tags: hero.tags || [],
  imageUrl: hero.imageUrl || '',
  videoMetadata: hero.videoMetadata || null,
  imageMetadata: hero.imageMetadata || null,
  targetKind: hero.targetKind || 'search',
  Product_id: hero.Product_id || null,
  Category_id: hero.Category_id || null,
  Collection_id: hero.Collection_id || null,
  Department_id: hero.Department_id || null,
  AllBrand_id: hero.AllBrand_id || null,
  targetLabel: hero.targetLabel || '',
  notes: hero.notes || ''
});

export const blankHero = () => ({
  term: '',
  searchQuery: '',
  status: 'accepted',
  isLive: false,
  videoUrl: '',
  imageUrl: '',
  videoMetadata: null,
  imageMetadata: null,
  targetKind: 'shopmy',
  sourceProductUrl: '',
  tags: [],
  Product_id: null,
  Category_id: null,
  Collection_id: null,
  Department_id: null,
  AllBrand_id: null,
  targetLabel: '',
  notes: ''
});

export const readMediaMetadata = (url, isVideo) =>
  new Promise(resolve => {
    if (!url) return resolve(null);
    const media = isVideo ? document.createElement('video') : new Image();
    const finish = result => {
      clearTimeout(timer);
      media.onloadedmetadata = media.onload = media.onerror = null;
      media.removeAttribute('src');
      resolve(result);
    };
    const timer = setTimeout(() => finish(null), 15000);
    media.onerror = () => finish(null);
    if (isVideo) {
      media.preload = 'metadata';
      media.onloadedmetadata = () => finish({ width: media.videoWidth, height: media.videoHeight, durationSeconds: media.duration || null });
    } else {
      media.onload = () => finish({ width: media.naturalWidth, height: media.naturalHeight });
    }
    media.src = url;
  });

export const filterHeroes = (heroes, { tab, query, liveOnly, videosOnly }) => {
  const term = query.trim().toLowerCase();
  return heroes.filter(hero => TABS.find(item => item.id === tab)?.statuses.includes(hero.status) &&
    (!liveOnly || hero.isLive) && (!videosOnly || hero.videoUrl) &&
    (!term || [hero.term, hero.targetLabel, hero.sourceProductUrl,
      ...(hero.tags || []).map(tag => tag.label)].filter(Boolean).join(' ').toLowerCase().includes(term)));
};
